import i18n from "i18next";
import Backend from "i18next-xhr-backend";
import { initReactI18next } from "react-i18next";
import { isVersionUK } from "./services/versionService";

const fallbackLng = ["uk"];
const supportedLngs = ["us", "uk"];

const separatedInstance = i18n.createInstance();

export const initialize = async () => {
    const defaultLanguage = isVersionUK ? "uk" : "us";
    if (separatedInstance.isInitialized) {
        await separatedInstance.reloadResources();
    } else {
        await separatedInstance
            .use(Backend) // load translation using xhr -> see /public/locales. We will add locales in the next step
            .use(initReactI18next) // pass the i18n instance to react-i18next.
            .init({
                backend: {
                    loadPath: "/locales/{{lng}}.json",
                    queryStringParams: { v: new Date().toISOString() },
                    crossDomain: true,
                    withCredentials: true,
                },
                fallbackLng,
                debug: true,
                supportedLngs,
                interpolation: {
                    escapeValue: false,
                },
                lng: defaultLanguage,
            });
    }
};

export default separatedInstance;
